import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route } from "react-router-dom";
import Footer from "../UI/Footer/Footer";
import Navigation from "../UI/Navigation/Navigation";
import PrivacySettings from "../../containers/PrivacySettings/PrivacySettings";

const PrivacySettingsLayout = (props) => {
  const { t } = useTranslation();
  const footerLinks = [
    { text: t("Privacy Policy"), key: "privacy" },
    { text: t("Legal Info"), key: "legal" },
    { text: t("Contact Us"), key: "contact" },
  ];
  useEffect(() => {
    document.title = `NVIDIA | ${t("GRANT PERMISSION")}`;
  });
  const locale = props.locale;
  return (
    <>
      <Navigation brandName={t("GRANT PERMISSION")} />
      <Route
        path="/:serviceType1/:version1/:serviceType2?/:version2?"
        render={(props) => <PrivacySettings {...props} locale={locale} />}
      />
      <Footer
        locale={props.locale.replace("_", "-").toLowerCase()}
        links={footerLinks}
      />
    </>
  );
};

export default PrivacySettingsLayout;
